module.exports = __webpack_public_path__ + "img/regiter-icon08.9a56dc3f.png";